import React from "react";
import { Link } from "react-router-dom";
// import bgMain from "../../assets/de-main-bg.jpg";
// import bgMain from "../../assets/de-main-bg.jpeg";
import bgMain from "../../assets/de-bg.jpeg";
import bgImage from "../../assets/de-ob-bg.png";
import deLogo from "../../assets/logo.png";
import deLogo2 from "../../assets/logo-2.png";

const LoginWrapper = (Component, signUp = false) => {
  class NewComponent extends React.Component {
    render() {
      return (
        <div className="h-screen flex">
          {/* form */}
          <div
            className="h-full w-1/2 flex flex-col justify-between items-center p-2"
            style={{ background: `url(${bgImage}) no-repeat center center` }}
          >
            <div className="flex justify-center w-full items-center h-[200px]">
              <img src={deLogo} alt="client-logo" className="w-60 h-auto" />
              {/* <div className='font-bold text-green-800 text-2xl'>DigiEnvision</div> */}
            </div>
            <div className="flex-1">
              <Component props={this.props} />
            </div>
            <div className="p-5 flex items-center gap-5">
              <span className="flex items-center gap-[10px]">
                <span>Powered by</span>
                <img src={deLogo2} className="w-[70px]" alt="eos-logo" />
              </span>
              <span>Copyrights &copy; 2025-2026.</span>
            </div>
          </div>
          {/* banner */}
          <div
            className="relative h-full w-1/2 flex justify-center items-center bg-main"
            style={{ backgroundImage: `url(${bgMain})` }}
          >
            {/* backdrop */}
            <div className="absolute top-0 left-0 bottom-0 right-0 bg-[#3e409533]"></div>
            {/* sign up */}
            {!signUp && (
              <div className="absolute top-5 right-5 z-[1]">
                <Link to="/register">
                  <button className="bg-white min-h-[40px] w-48 rounded-md text-[#3e4095] flex justify-center items-center">
                    Create Account
                  </button>
                </Link>
              </div>
            )}
            {/* content */}
            {/* <div className='text-white font-bold text-4xl z-[1] w-3/5'>It's time to bring your business online.</div> */}
          </div>
        </div>
      );
    }
  }
  return NewComponent;
};

export default LoginWrapper;
